import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    flex: 1,
    width: '100%'
  },
  input: {
    width: '100%',
    padding: 8,
    fontSize: 14
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/standard-input/standard-input-styles.js